var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTelephoneSmall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "telephone 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M37.2341 32.7625C35.6852 31.2334 33.7516 31.2334 32.2126 32.7625C31.0386 33.9266 29.8646 35.0908 28.7103 36.2746C28.3946 36.6001 28.1282 36.6692 27.7435 36.4522C26.9838 36.0378 26.1748 35.7024 25.4448 35.2486C22.0412 33.1078 19.19 30.3554 16.6644 27.2577C15.4115 25.7187 14.2967 24.0712 13.5173 22.2165C13.3594 21.8416 13.389 21.595 13.6949 21.2892C14.8689 20.1547 16.0133 18.9906 17.1676 17.8265C18.7756 16.2086 18.7756 14.3144 17.1577 12.6866C16.2402 11.7593 15.3227 10.8517 14.4052 9.92435C13.4581 8.97728 12.5209 8.02035 11.5639 7.08315C10.015 5.57375 8.08136 5.57375 6.54233 7.09301C5.35846 8.25712 4.22392 9.45082 3.02032 10.5952C1.90551 11.6508 1.34317 12.9431 1.22479 14.4525C1.03734 16.909 1.63914 19.2273 2.48758 21.4865C4.22392 26.1627 6.8679 30.3159 10.0742 34.124C14.4052 39.2736 19.5748 43.348 25.6224 46.2879C28.3453 47.6098 31.1668 48.6259 34.235 48.7937C36.3462 48.912 38.1812 48.3793 39.6512 46.7318C40.6575 45.6072 41.792 44.5812 42.8575 43.5059C44.436 41.9077 44.4459 39.9741 42.8772 38.3956C41.0028 36.5114 39.1185 34.6369 37.2341 32.7625Z",
    fill: "#52682F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M35.6578 24.9999L39.2857 24.367C38.7155 20.9614 37.1424 17.8772 34.7532 15.4259C32.2264 12.844 29.0311 11.2165 25.5113 10.7142L25 14.4414C27.7234 14.8332 30.2011 16.089 32.1576 18.0882C34.006 19.9768 35.2153 22.3678 35.6578 24.9999Z",
    fill: "#52682F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M41.14 8.98194C36.8747 4.71564 31.478 2.02166 25.5206 1.19043L25 4.90592C30.1464 5.62698 34.8122 7.96043 38.4967 11.6359C41.9911 15.131 44.2839 19.5475 45.1149 24.4047L48.8095 23.7738C47.8383 18.1455 45.185 13.0379 41.14 8.98194Z",
    fill: "#52682F"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelephoneSmall);
export default __webpack_public_path__ + "static/media/telephone-small.ef3e718b5f767d3966aa66d9c7c18304.svg";
export { ForwardRef as ReactComponent };